import { render, staticRenderFns } from "./screenshot-list.vue?vue&type=template&id=331a4302"
import script from "./screenshot-list.vue?vue&type=script&lang=js"
export * from "./screenshot-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports